import { BrowserRouter } from 'react-router-dom';
import './App.css';
import './style/Common.scss';
import './style/Color.scss'
import ScreenNavigators from './components/navigator'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScreenNavigators />
        <ToastContainer 
          autoClose={3000}
          position="top-right"
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          />
      </BrowserRouter>
    </div>
  );
}

export default App;


